import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { type ApplicationStage, ApplicationKind } from '../../../api/types';
import { useMultipleDealerIds } from '../../../components/contexts/DealerContextManager';
import { getDocType } from '../../../utilities/useGetEventDocumentDetailsEndpoint';
import ApplicationList from '../../shared/ApplicationList';
import { getApplicationColumns } from '../../shared/ApplicationList/helpers';

export type FinderVehicleApplicationListProps = {
    finderVehicleVin: string;
    stage: ApplicationStage;
    setSelectedApplications: React.Dispatch<React.SetStateAction<string[]>>;
};
const FinderVehicleApplicationList = ({
    finderVehicleVin,
    stage,
    setSelectedApplications,
}: FinderVehicleApplicationListProps) => {
    const { dealerIds } = useMultipleDealerIds();
    const showColumns = useMemo(() => getApplicationColumns(stage, { hasModule: false }), [stage]);

    const navigate = useNavigate();
    const onRow = useCallback(
        id => {
            navigate(`/admin/${getDocType(stage)}/${id}`);
        },
        [navigate, stage]
    );

    if (!stage) {
        return null;
    }

    return (
        <ApplicationList
            dealerIds={dealerIds}
            finderVehicleVin={finderVehicleVin}
            kind={ApplicationKind.Finder}
            onRow={onRow}
            setSelectedApplication={setSelectedApplications}
            showColumns={showColumns}
            stage={stage}
        />
    );
};

export default FinderVehicleApplicationList;
